import React, { useState } from 'react';
import { styled } from '@mui/system';
import InputBase from '@mui/material/InputBase';
import Box from '@mui/material/Box';

const Container = styled(Box)({
    margin: '20px 0px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#FAFAFA',
    border: '1px solid #CFCFCF',
    borderRadius: '10px',
    padding: '8px',
});

const StyledInput = styled(InputBase)(({ theme }) => ({
    '& .MuiInputBase-input': {
        borderRadius: '100px',
        backgroundColor: 'white',
        border: `2px solid #6174DD`,
        padding: theme.spacing(1),
        width: '100px',
        textAlign: 'center',
    },
}));

function BoxInputs({ title }) {
    const [value, setValue] = useState('0');

    const handleChange = (event) => {
        const inputValue = event.target.value;

        // Extract the numeric value from the input
        const numericValue = inputValue.replace(/[^0-9]/g, '');

        // Update the value state with the numeric value
        setValue(numericValue);
    };

    // const handleSubmit = (event) => {
    //     event.preventDefault();
    //     // Handle form submission here
    // };

    return (
        <Container>
            <span>{title}</span>
            <StyledInput
                type="text"
                value={`INR ${value}`}
                onChange={handleChange}
                placeholder="0"
                inputProps={{ 'aria-label': 'custom input' }}
            />
        </Container>
    );
}

export default BoxInputs